import { createEvent, restore, sample } from 'effector'
import { fx, path } from 'src/libs'
import { languages } from '../../../../../libs/languages'
import { SocialMediaGroupItem } from '../types'
import { toPath } from '../../../../../features/router'
import { getOffers } from '../../offers/list/model'
import { Offer } from '../../offers/list/types'

export const offersByLangMounted = createEvent<{ lang: string }>()

export const setSocialMediaGroupForm = createEvent<SocialMediaGroupItem>()

export const submitCreateSocialMediaGroup = createEvent<SocialMediaGroupItem>()

export const $socialMediaGroup = restore(setSocialMediaGroupForm, {
  lang: `${languages[0].value}`,
  title: '',
  offerId: 0,
  isVisible: true,
})

export const $offersByLang = restore<Offer[]>(
  getOffers.doneData.map((a) => a.body.items),
  [],
)

export const createSocialMediaGroup = fx<SocialMediaGroupItem, void>({
  method: 'POST',
  url: '/partner/material/social_media',
})

sample({
  clock: submitCreateSocialMediaGroup,
  fn: (socialMediaGroup) => {
    return {
      url: `/partner/material/social_media`,
      body: { ...socialMediaGroup },
    }
  },
  target: createSocialMediaGroup,
})

sample({
  clock: [createSocialMediaGroup.doneData],
  target: toPath.prepend(path.ib.ad.socialMedia.entry),
})

sample({
  // @ts-ignore
  clock: offersByLangMounted,
  fn: ({ lang }) => {
    let query = {
      lang,
    }

    return {
      query,
    }
  },
  target: getOffers,
})
